module.exports = __webpack_public_path__ + "static/assets/1afd0fa592eb25f2d26173c78211acc4.png";